import { ginzaxiaomaApiRequest } from 'apis';
import {
  PmsProductMaterialCategoryOption,
  PmsProductMaterialCreateDto,
  PmsProductMaterialRecord,
  PmsProductMaterialUpdateDto,
} from 'types/pms-product-material';

export const productMaterialCategoryOptions = () => {
  return ginzaxiaomaApiRequest.get<PmsProductMaterialCategoryOption[]>(
    '/admin/pms/product-material/category-options',
  );
};

export const productMaterialList = (categoryId: number) => {
  return ginzaxiaomaApiRequest.post<{ list: PmsProductMaterialRecord[] }>(
    '/admin/pms/product-material/list',
    { categoryId },
  );
};

export const productMaterialCreate = (data: PmsProductMaterialCreateDto) => {
  return ginzaxiaomaApiRequest.post<PmsProductMaterialRecord>(
    '/admin/pms/product-material/create',
    data,
  );
};

export const productMaterialUpdate = (
  id: number,
  data: PmsProductMaterialUpdateDto,
) => {
  return ginzaxiaomaApiRequest.post<PmsProductMaterialRecord>(
    `/admin/pms/product-material/update/${id}`,
    data,
  );
};

export const productMaterialUpdateEnable = (id: number, enable: 0 | 1) => {
  return ginzaxiaomaApiRequest.post<PmsProductMaterialRecord>(
    `/admin/pms/product-material/update-enable/${id}`,
    { enable },
  );
};
